import { motion } from "framer-motion";
import { ShieldCheck, X, Check } from "lucide-react";

const GuaranteeSection = () => {
  return (
    <section className="py-20 md:py-28 bg-muted/40">
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-5xl mx-auto bg-card rounded-3xl p-8 md:p-12 shadow-xl border-2 border-accent/30 relative overflow-hidden"
        >
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-accent/10 rounded-full blur-3xl" />

          <div className="grid md:grid-cols-2 gap-10 items-center relative">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/15 text-accent text-xs font-bold uppercase tracking-wider mb-5">
                <ShieldCheck className="w-4 h-4" /> The Culver City Guarantee
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-5">
                Page one in 90 days.{" "}
                <span className="gold-gradient-text">Or you don't pay another cent.</span>
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                We're so confident in our local SEO process that we put our money on the line. If
                we don't get you on page one of Google for your agreed-upon Culver City keywords
                within 90 days, your next month is free. Period.
              </p>
            </div>

            <div className="space-y-3">
              <div className="text-sm font-semibold text-foreground mb-3">
                What you get vs. typical agencies:
              </div>
              {[
                { ok: true, text: "Local team based in LA — never offshored" },
                { ok: true, text: "Month-to-month, no 12-month contracts" },
                { ok: true, text: "Direct Slack with your strategist" },
                { ok: true, text: "Transparent reporting every Monday" },
                { ok: false, text: "Junior account managers reading scripts" },
                { ok: false, text: "Vague 'awareness' metrics with no ROI" },
              ].map((row, i) => (
                <div key={i} className="flex items-start gap-3 text-sm">
                  {row.ok ? (
                    <div className="w-5 h-5 rounded-full bg-secondary/15 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <Check className="w-3 h-3 text-secondary" />
                    </div>
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-destructive/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <X className="w-3 h-3 text-destructive" />
                    </div>
                  )}
                  <span
                    className={
                      row.ok
                        ? "text-foreground"
                        : "text-muted-foreground line-through"
                    }
                  >
                    {row.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GuaranteeSection;
